export const TRANSPORT_EVENTS_UUIDS = {
  registered: '617303b4-d245-4638-abb2-9c0c6660c6fb',
  pickedUp: 'ac0b2b3a-fea2-4c78-89c5-7b346edf766e',
  arrivalAtDepot: '1b0c2da9-093d-44c8-8ac9-1b631fe1dc71',
  departureFromDepot: '8d56d5aa-a317-4c54-8d6c-bb329fcb3fed',
  pickupPostponed: '44eecddd-44b2-4a6d-a899-57471bd556f4',
  deliveryPostponed: '6764fa64-5c90-41be-933e-f7d763fc0c65',
  delivered: '56d0438f-aa88-45ca-b8b4-fdda83b9ef59',
  cancel: '6d9d5a5d-01b8-427e-8b00-886df3f95c44',
  goingToLinkoping: '66517279-f71f-43a9-ba7c-0b07f942eed6',
};

export const TRACKING_CASES = {
  // Sipariş sisteme kaydedildi, pickup tarihi henüz gelmedi
  registered: 'registered', // B826049A
  // Pickup günü geldi ve sürücü yola çıktı
  outForPickup: 'outForPickup',
  // Pickup günü geldi, tahmini varış aralığı mevcut (sürücü sizi almaya geliyor)
  intervalPickup: 'intervalPickup',
  // Paket sürücü tarafından teslim alındı
  pickedUp: 'pickedUp',
  // Paket depoya ulaştı
  arrivalAtDepot: 'arrivalAtDepot',
  // Paket depodan ayrıldı, yola çıktı
  departureFromDepot: 'departureFromDepot',
  // Teslimat günü geldi, tahmini varış aralığı mevcut (sürücü teslimata geliyor)
  intervalDelivery: 'intervalDelivery',
  // Sipariş iptal edildi
  cancelled: 'cancelled',
  // Paket alıcıya teslim edildi
  delivered: 'delivered',
  // Sipariş bulunamadı veya tanımsız durum
  notFound: 'notFound',
  // Teslimat günü geldi ve sürücü yola çıktı (interval yok)
  outForDelivery: 'outForDelivery',
  // Pickup veya delivery ertelendi
  postponed: 'postponed',
  // Paket Linköping'e gidiyor (transit, depot değil)
  goingToLinkoping: 'goingToLinkoping',
};

// departureFromDepot B023872D
